import {
  AuthenticationService,
  AuthenticateExchangeTokenResult,
  AuthenticateRequest,
  AuthenticationResult,
  CreateExchangeTokenRequest,
  ExchangeTokenData,
  ExchangeTokenRequest,
  ExchangeTokenStatus,
  UserFeedbackOptions,
  UserFeedbackRequest,
  Authentication,
} from './authenticationService';
import MockableAuthenticationService from './mockableAuthenticationService';
import AuthenticationServiceImplementation from './authenticationServiceImplementation';

const isE2e =
  (process.env.REACT_APP_STAGE || 'unknown') === 'e2e' || (process.env.REACT_APP_STAGE || 'unknown') === 'preprod_e2e';
const authenticationService: AuthenticationService = isE2e
  ? new MockableAuthenticationService()
  : new AuthenticationServiceImplementation();

export default authenticationService;
export { ExchangeTokenStatus };

export type {
  AuthenticateRequest,
  AuthenticationResult,
  CreateExchangeTokenRequest,
  ExchangeTokenRequest,
  AuthenticateExchangeTokenResult,
  ExchangeTokenData,
  UserFeedbackOptions,
  UserFeedbackRequest,
  Authentication,
};
